var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/Any.js
 ** module id = 10
 ** module chunks = 0
 **/